import { client } from '../../api/client';
import WhatsAppTemplatesSectionBase from '../../../modules/whatsapp-templates/frontend/WhatsAppTemplatesSection';

export default function WhatsAppTemplatesSection() {
  return <WhatsAppTemplatesSectionBase apiFetch={client.api.fetch} />;
}
